var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "center" }, [
    _vm.connectionFailed
      ? _c(
          "div",
          { staticClass: "connection-error" },
          [
            _c("h1", [_vm._v("\n      V delu...\n    ")]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-4" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.getErrorMessage(_vm.errCode)) + "\n    "
              )
            ]),
            _vm._v(" "),
            _c("input-button", {
              attrs: { inputPlaceholder: "Back to Qwilink" },
              on: { click: _vm.returnToQwilink }
            })
          ],
          1
        )
      : _c("div", [_c("h1", [_vm._v("\n      Working on it...\n    ")])])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e151e62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e151e62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/route/screenLogin/SsoResponseHandler.vue
// module id = null
// module chunks = 